import {
  deletePersonalUploadFile,
  cancelUploadFile,
  getUploadStatusList,
} from '~/api'
import { UploadStatus } from '~/api/interface/file'
import { useRegisterRefreshRemove } from '~/features/oss-upload/service'
/** 这里会触发循环引用问题 */
import { useUpload, type IFile } from '~/hooks/useUpload'

interface UploadItem extends IFile {
  id?: number
  update_time?: string
  filename?: string
}

interface DataType {
  model_type?: typeof COLLECTION_MAP
  resource_type?: any
  media_type?: FILE_TYPE_MAP
  source?: any
  upload_type?: any
  [key: string]: any
}

interface UploadListProps {
  title?: string
  accept?: string
  params?: DataType
  onSuccess?: (data?: any) => void
}

export const useUploadList = (props: UploadListProps) => {
  const { $t } = useNuxtApp()
  let uploadSecretIds: string[] = [] // 正在上传中的
  const fileList = ref<IFile[]>([]) // 上传中和后端正在处理的
  const { open } = useUpload({
    title: props?.title,
    params: props.params,
    accept: props.accept,
    multiple: true,
    hasMessage: false,
    onChange: (file) => {
      fileList.value.unshift(file)
    },
    onSuccess: (file: IFile) => {
      initTimer(file)
      uploadSecretIds = uploadSecretIds.filter(
        (item) => item !== file.upload_secret_id
      )
    },
    onProgress: (file) => {
      if (
        file.upload_secret_id &&
        !uploadSecretIds.includes(file.upload_secret_id)
      ) {
        uploadSecretIds.push(file.upload_secret_id)
      }

      const index = fileList.value.findIndex(
        (f) =>
          f.uid === file.uid || f.upload_secret_id === file.upload_secret_id
      )
      if (index > -1) {
        fileList.value[index] = { ...file }
        fileList.value = [...fileList.value]
      }
    },
    onError: (file) => {
      // initTimer(file)
    },
  })

  let timer: NodeJS.Timeout | undefined
  const getStatus = async (file?: IFile) => {
    const { resource_type } = props.params || {}
    const res = await getUploadStatusList({
      ...props.params,
      resource_type:
        resource_type === RESOURCE_TYPE.TEMPLATE ? undefined : resource_type,
    })

    closeTimer()

    const oldLength = fileList.value.length

    res.data?.forEach((item) => {
      if (item.upload_status === UploadStatus.UPLOADING) {
        const originFile = fileList.value.find(
          (file) => file.upload_secret_id === item.upload_secret_id
        )
        item.percent = originFile?.percent ? originFile.percent : item.percent
      }
    })

    fileList.value = (res.data || []) as unknown as IFile[]
    if (oldLength > 0 && fileList.value.length !== oldLength && file) {
      props?.onSuccess?.(file)
    }
    const list = fileList.value.filter(
      (f) => ![UPLOAD_STATUS.ERROR].includes(f.upload_status)
    )
    if (list.length > 0) {
      timer = setTimeout(getStatus, 1000 * 5)
    }
  }

  const initTimer = (file?: IFile) => {
    closeTimer()
    getStatus(file)
  }

  const closeTimer = () => {
    if (timer) {
      clearTimeout(timer)
      timer = undefined
    }
  }

  const handClose = async (file: UploadItem) => {
    const res = await deletePersonalUploadFile({
      upload_secret_id: file.upload_secret_id,
    })
    if (res.code !== 0) {
      return
    }
    message.success($t('shan-chu-cheng-gong-0'))
    fileList.value = fileList.value.filter(
      (item: UploadItem) => file?.upload_secret_id !== item?.upload_secret_id
    )
  }

  const handCancel = async (
    file: { upload_secret_id: string },
    showMsg: boolean = true
  ) => {
    await cancelUploadFile({
      upload_secret_id: file.upload_secret_id,
      delete_data: true,
    })

    if (showMsg) {
      message.success($t('qu-xiao-shang-chuan-cheng-gong'))
    }

    fileList.value = fileList.value.filter(
      (item: UploadItem) => file?.upload_secret_id !== item?.upload_secret_id
    )
  }

  useRegisterRefreshRemove(uploadSecretIds)

  return {
    handOpen: open,
    initTimer,
    closeTimer,
    handClose,
    handCancel,
    fileList,
  }
}
